import {
  Theme,
  border2,
  inputElementStyles,
  optionStyles,
  propertyColorStyles,
  radius,
  rem,
  spacing,
  token,
} from '@thiememeulenhoff/lit-sdk';
import { PropertyColor } from '@thiememeulenhoff/types';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('text-input');
export const theme = new Theme(tag);

const propertyColorCallback = (propertyColor: PropertyColor) => {
  const selector = unsafeCSS(`[color=${propertyColor}]`);

  return css`
    :host(${selector})
      :where(input):not([disabled]):where(:focus, :focus-visible) {
      border-color: ${token('albert-text-input-border-focus')};
    }
  `;
};

const propertyColorStyle = propertyColorStyles(propertyColorCallback);

export const styles = [
  optionStyles,
  css`
    :host {
      align-items: normal;
      display: flex;
      flex-direction: column;
      row-gap: ${spacing(50)};
    }

    :where(.input-wrapper) {
      display: inline-block;
      inline-size: 100%;
      position: relative;
    }

    :where(label) {
      display: none;
      font-weight: bold;
    }

    :where(.show) {
      display: block;
    }

    :where(slot[name='error']) {
      color: ${token('input-helper-error')};
    }

    :where(slot[name='description']) {
      color: ${token('foreground-secondary')};
      font-size: ${rem(14)};
    }

    :where(input) {
      ${inputElementStyles};
      background-color: ${token('input-background-default')};
      block-size: auto;
      box-sizing: border-box;
      display: block;
      inline-size: 100%;
      line-height: 1.5;
    }

    :where(input.size-large) {
      /* TODO: no matching spacing token for 14px */
      padding: ${rem(14)};
    }

    :where(input.pill) {
      border-radius: ${radius('extra-large')};
    }

    :where(input)::placeholder {
      color: ${token('foreground-tertiary')};
      font-size: ${rem(16)};
      opacity: 1;
    }

    :where(a-icon) {
      color: ${token('input-foreground-default')};
    }

    :where(.clickable) {
      cursor: pointer;
    }

    :where(.reset) {
      color: ${token('text-secondary')};
      cursor: pointer;
      display: none;
    }

    :where(.input-wrapper.has-content) {
      :where(.reset) {
        display: block;
      }
    }

    :where(.input-wrapper.with-icon) {
      :where(input) {
        /* TODO: no matching spacing token for 30px */
        padding-inline-end: 30px;
      }
    }

    :where(.input-wrapper.with-icon-and-reset) {
      :where(input) {
        /* TODO: no matching spacing token for 70px */
        padding-inline-end: 70px;
      }
      :where(.reset) {
        border-inline-end: ${border2(1, 'border-secondary')};
        inset-inline-end: ${rem(36)};
        padding-inline-end: ${spacing(100)};
      }
    }

    :where(input.error) {
      border-color: ${token('status.danger.foreground')};
    }

    :host([disabled]) {
      :where(input) {
        background: ${token('albert-text-input-background-disabled')};
        border: ${border2(1, 'input-border-disabled')};
        color: ${token('albert-text-input-foreground-disabled')};
        cursor: not-allowed;
      }
      :where(input)::placeholder {
        color: ${token('albert-text-input-foreground-disabled')};
      }
      :where(a-icon) {
        color: ${token('albert-text-input-foreground-disabled')};
      }
    }

    .error {
      color: ${token('input-helper-error')};
    }

    .small {
      font-size: ${rem(12)};
    }
  `,
  propertyColorStyle,
];
